module.exports = __webpack_public_path__ + "static/img/UTM老师_Nick.99924e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_Nick.png
// module id = /Typ
// module chunks = 0